export default function Services() {
  return (
    <section id="services" className="py-24 lg:py-32 bg-stone-50">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="mb-16">
          <p className="text-sm font-medium text-gray-500 tracking-wider uppercase mb-3">
            WHAT WE DO
          </p>
          <h2 className="text-5xl lg:text-6xl font-bold text-gray-900">
            Our Services
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          <div className="bg-akten-surface rounded-3xl p-10 flex flex-col justify-between min-h-[420px]">
            <div>
              <h3 className="text-3xl font-bold text-white mb-6">
                Wholesale & Distribution
              </h3>
              <p className="text-gray-300 leading-relaxed">
                We source inventory directly from authorized wholesalers and publishers, focusing on long-term, sustainable relationships built on trust and clear communication. Our team handles catalog onboarding, pricing strategy, and marketplace readiness so your products are positioned to succeed from day one.
              </p>
            </div>
          </div>

          <div className="relative rounded-3xl overflow-hidden min-h-[420px]">
            <img
              src="https://readdy.ai/api/search-image?query=amazon%20walmart%20marketplace%20ecommerce%20platform%20digital%20commerce%20operations%20online%20retail%20business%20professional%20technology%20interface%20modern%20shopping%20experience&width=600&height=800&seq=marketplace-ops-002&orientation=portrait"
              alt="Marketplace Operations"
              className="w-full h-full object-cover"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/30 to-transparent"></div>
            <div className="absolute top-8 left-8">
              <div className="flex items-center space-x-2 bg-white/10 backdrop-blur-md px-4 py-2 rounded-full">
                <i className="ri-store-2-line text-white text-lg"></i>
                <span className="text-white text-sm font-medium">Operations</span>
              </div>
            </div>
            <div className="absolute bottom-8 left-8 right-8">
              <h3 className="text-3xl font-bold text-white">
                Marketplace Operations
              </h3>
            </div>
          </div>

          <div className="bg-white rounded-3xl p-10 flex flex-col justify-between min-h-[420px] border border-gray-200">
            <div>
              <h3 className="text-3xl font-bold text-gray-900 mb-6">
                Fulfillment & Logistics
              </h3>
              <p className="text-gray-600 leading-relaxed mb-8">
                We coordinate inventory planning, order fulfillment, and returns processing with a focus on reliability, accuracy, and execution.
              </p>
            </div>
            <div className="rounded-2xl overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=logistics%20fulfillment%20center%20organized%20packages%20shipping%20boxes%20inventory%20management%20systematic%20warehouse%20operations%20efficient%20supply%20chain%20professional%20distribution&width=600&height=300&seq=logistics-003&orientation=landscape"
                alt="Logistics"
                className="w-full h-48 object-cover"
              />
            </div>
          </div>
        </div>

        <div className="mt-8 bg-akten-surface rounded-3xl p-10">
          <div className="flex flex-col md:flex-row md:items-center md:justify-between">
            <div className="mb-6 md:mb-0">
              <h3 className="text-2xl font-bold text-white mb-3">
                Marketplace Operations
              </h3>
              <p className="text-gray-300 max-w-2xl">
                We manage the day-to-day operations of your listings on Amazon, Walmart, and other major marketplaces — from offer optimization to policy compliance and performance monitoring.
              </p>
            </div>
            <div className="flex items-center space-x-8">
              <a href="https://www.amazon.com" target="_blank" rel="noopener noreferrer" className="cursor-pointer">
                <i className="ri-amazon-line text-white text-5xl"></i>
              </a>
              <a href="https://www.walmart.com" target="_blank" rel="noopener noreferrer" className="cursor-pointer">
                <img 
                  src="https://static.readdy.ai/image/8d92607123ebd7e39393fafa79bd6936/e9c4fcc1c4a8249a88a1100cec9d1027.png" 
                  alt="Walmart" 
                  className="h-12 brightness-0 invert"
                />
              </a>
              <a href="https://www.ebay.com" target="_blank" rel="noopener noreferrer" className="cursor-pointer">
                <img 
                  src="https://static.readdy.ai/image/8d92607123ebd7e39393fafa79bd6936/5b1329bdebffecf5f3f965714996ae18.png" 
                  alt="eBay" 
                  className="h-9 brightness-0 invert"
                />
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}